// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// 🔑 Replace these values with your Firebase project config
const firebaseConfig = {
    apiKey: "AIzaSyAYLydgzUitpvPQNxvv8EhtaSd4nWz9iXE",
    authDomain: "winedefull.firebaseapp.com",
    projectId: "winedefull",
    storageBucket: "winedefull.firebasestorage.app",
    messagingSenderId: "100638776403",
    appId: "1:100638776403:web:0a85dca4cc967ed13bbaa6",
    measurementId: "G-K1EC4EH8LN"
  };
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app); // ✅ add this

// Export everything you need
export { db, analytics, auth };
